require('./attach-file.less');

jQuery(function() {
    $(document).on('change', '.js-attach-file-input-controll', function() {
        let isSelected = ($(this).val().length > 0);
        let selectedBox = $(this).next();
        if (isSelected) {
            selectedBox.find('span').text('[' + $(this)[0].files.length + ']');
        }
    });
});


// WEBPACK FOOTER //
// ./blocks/attach-file/attach-file.js